import { setTerm } from './helpers';

export const setSalesLeader = setTerm('is_sales_leader');
